import {DatePicker as DatePickerAntd, type DatePickerProps} from 'antd'
import type {RangePickerProps} from 'antd/lib/date-picker'
import React, {useEffect, useRef, useState} from 'react'
import LabelText from '../LabelText'
import '../LabelText/index.less'

export type TDatePickerProps = DatePickerProps & {prefix?: string}
export type TRangePickerProps = RangePickerProps & {prefix?: string}

const DatePicker = (props: TDatePickerProps) => {
  const r = useRef<any>(null)
  const addPrefix = () => {
    if (r.current?.nativeElement?.querySelector('astro-ui-label-text')) {
      return
    }

    const label = document.createElement('span')
    label.className = 'astro-ui-label-text input-prefix'
    label.innerHTML = props?.prefix || ''
    r.current?.nativeElement?.insertBefore(label, r.current?.nativeElement?.firstChild)
  }
  const prefix = <LabelText text={props.prefix} inputLabel={true}></LabelText>
  useEffect(() => {
    if (props?.prefix) {
      // addPrefix()
    }
  }, [props?.prefix])

  return <DatePickerAntd ref={r} {...props} prefix={props.prefix ? prefix : ''} />
}

const RangePicker = (props: TRangePickerProps) => {
  const r = useRef<any>(null)
  const addPrefix = () => {
    if (r.current?.nativeElement?.querySelector('astro-ui-label-text')) {
      return
    }

    const label = document.createElement('span')
    label.className = 'astro-ui-label-text input-prefix'
    label.innerHTML = props?.prefix || ''
    r.current?.nativeElement?.insertBefore(label, r.current?.nativeElement?.firstChild)
  }
  const prefix = <LabelText text={props.prefix} inputLabel={true}></LabelText>
  useEffect(() => {
    if (props?.prefix) {
      // resetPrefix()
    }
  }, [props?.prefix])

  return <DatePickerAntd.RangePicker ref={r} {...props} prefix={props.prefix ? prefix : ''} />
}

DatePicker.RangePicker = RangePicker

export default DatePicker
